import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M6 4h10v2H6z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 2H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6h1v4H9v11c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h8V4h-3V3c0-.55-.45-1-1-1zm-1 4H6V4h10v2z"
})), 'FormatPaintTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FormatPaintTwoTone.js
// module id = 3878
// module chunks = 2